Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */
var s4 = function () {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};
exports.default = (function () { return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4(); });
